import { Entity } from '@backstage/catalog-model';
import { BACKSTAGE_SOURCE_LOCATION, SEV_2_PROJECT_BOARD_URL } from '../constants';

export const isSev2BoardAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[SEV_2_PROJECT_BOARD_URL]);

export const isTribe = (entity: Entity) : boolean => {
  const source = entity.metadata.annotations?.[BACKSTAGE_SOURCE_LOCATION];
  return Boolean(source?.endsWith("/groups/tribes/"));
}
